import { Pipe, PipeTransform } from '@angular/core';
import {
    EnumTranslationTypes,
    TranslationsService,
} from '../../services/translations';

@Pipe({
    name: 'translateTokenisedString',
})
export class TranslateTokenisedStringPipe implements PipeTransform {
    constructor(private translationsService: TranslationsService) {}

    transform(
        value: string | undefined | null,
        params?: { [key: string]: string },
        enumType?: EnumTranslationTypes,
    ): string {
        if (!value) {
            return '';
        }

        if (enumType) {
            const translationKey = `ENUM_${enumType}_${value?.toUpperCase()}`;
            return this.translationsService.translateTokenisedString(
                translationKey,
                params,
            );
        }

        return this.translationsService.translateTokenisedString(value, params);
    }
}
